<app-confirmation-dialog
    [message]="dialogMessage"
    [display]="displayConfirmationDialog"
    (accept)="ondialogaccept()"
    (cancel)="onCancelDialog()"
></app-confirmation-dialog>
<div class="sidebar" [ngClass]="{ 'collapsed': isCollapsed }">
    <p-dialog
        header="Search Chats"
        [(visible)]="searchDialogVisible"
        [modal]="true"
        [draggable]="false"
        [appendTo]="'body'"
        [style]="{
            width: '850px',
            height: '500px',
            'border-radius': '0.5rem',
            overflow: 'hidden'
        }"
        [contentStyle]="{
            height: '450px',
            overflow: 'hidden',
            'border-radius': '0 0 0.5rem 0.5rem'
        }"
        styleClass="search-modal"
        (onHide)="closeSearchDialog()"
        >
        <div class="p-input-icon-left search-modal-input">
            <i class="pi pi-search"></i>
            <input
            pInputText
            [(ngModel)]="searchText"
            (keyup)="searchTextUpdate.next(searchText)"
            placeholder="Search your chats"
            class="searchInput"
            />
        </div>
        <div class="loaderContainer" *ngIf="searchLoading">
          <div class="loaderSpinner"></div>
        </div>
        <div *ngIf="!searchLoading && searchText.trim() === ''" class="no-results">
          <div style="height: 25%;">Search results will appear here once you start typing</div>
        </div>
        <div *ngIf="!searchLoading && searchResults === 'No Results' && searchText.trim() !== ''" class="no-results">
          <div style="height: 25%;">No Results</div>
        </div>
        <div class="search-results" (scroll)="onScroll($event)" *ngIf="!searchLoading && searchResults instanceof Array && searchResults.length > 0">
          <div *ngFor="let result of searchResults" class="search-result" (click)="onSearchChatClick(result)" (keydown.enter)="onSearchChatClick(result)" style="cursor: pointer;">
            <div class="chat-name">
              <span [innerHTML]="result.chatName | highlight: searchText" class="highlighted-word font-extrabold"></span>
            </div>
            <div class="interaction-snippet">
              <span [innerHTML]="'...' + result.interaction.textSnippet + '...' | highlight: searchText" class="highlighted-word font-extrabold"></span>
            </div>
          </div>
        </div>
        <div class="bottom-loader" *ngIf="isFetchingResults">
          <div class="loaderSpinner"></div>
        </div>
    </p-dialog>
    <div class="sidebar-header">
        <div
            class="sidebar-header-search-wrapper"
            (mouseenter)="showSearchTooltip = true"
            (mouseleave)="showSearchTooltip = false"
            >
            <button
                type="button"
                class="search-btn search-btn-small"
                (click)="onSearchClick()"
            >
                <i class="pi pi-search"></i>
            </button>
            <!-- tooltip matching chevron hover UI -->
            <div *ngIf="showSearchTooltip" class="custom-tooltip-icon">
                Search Chats
            </div>
        </div>
        <div class="split-button-container flex align-items-center" *ngIf="!isCollapsed">
            <!-- Split Button -->
            <p-splitButton
                [label]="selectedChatType"
                icon="pi pi-plus"
                [dropdownIcon]="!isDropdownOpen ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
                outlined
                severity="contrast"
                pTooltip="Switch Data Source"
                tooltipPosition="bottom"
                (onClick)="selectUpdateChatType()"
                [model]="selectedsplitButtonItems"
                (onDropdownClick)="toggledropdown()"
                class="p-button-outlined-secondary btnClass custom-split-button"
                [ngClass]="{ 'quilt-beta-selected': selectedChatType === quiltBetaLabel }"
            ></p-splitButton>
        </div>
  </div>

    <div
    class="search-button-wrapper"
    [ngClass]="{ 'collapsed': isCollapsed }"
    (mouseenter)="showSearchTooltip = true"
    (mouseleave)="showSearchTooltip = false"
    >
    <button
        type="button"
        class="search-btn circle-btn"
        (click)="onSearchClick()"
    >
        <i class="pi pi-search"></i>
    </button>
    <!-- tooltip matching chevron hover UI -->
    <div *ngIf="showSearchTooltip" class="custom-tooltip-icon">
        Search Chats
    </div>
    </div>

    <div
    class="toggle-wrapper"
    [ngClass]="{ 'collapsed': isCollapsed }"
    (mouseenter)="showTooltip = true"
    (mouseleave)="showTooltip = false"
    >
    <button
    type="button"
    (click)="emitToggle()"
    class="circle-btn"
    >
    <i [ngClass]="isCollapsed ? 'pi pi-angle-double-right' : 'pi pi-angle-double-left'"></i>
    </button>

    <div *ngIf="showTooltip" class="custom-tooltip-icon">
    {{ isCollapsed ? 'Expand' : 'Collapse' }}
    </div>
    </div>



    <div class="loaderContainer" *ngIf="isloading">
        <div class="loaderSpinner"></div>
    </div>
    <div
        (scroll)="scrollUpdate.next($event)"
        class="allChat chatsOverflow mt-3 scroll-container"
        *ngIf="!isloading && !isCollapsed"
    >
        <div *ngFor="let chat of allChats; let idx = index">
            <div
                class="chatsListContainer mb-2"
                *ngIf="chat?.chats?.length > 0"
            >
                <button
                  type="button"
                  (click)="updateCurrentChatPeriod(idx)"
                  class="rounded-0 btn btn-secondary custom-btn w-100 py-2"
                >
                  <span class="mr-3">{{ chat.name }}</span>
                  <i *ngIf="!chat.showChats" class="pi pi-chevron-down chevron"></i>
                  <i *ngIf="chat.showChats" class="pi pi-chevron-up chevron"></i>
                </button>
                <div class="w-100" *ngIf="chat.showChats">
                    <div
                        *ngFor="let option of chat.chats; let i = index "
                        [attr.data-id]="option.chatId"
                        [ngClass]="
                            activeChat && activeChat?.chatId === option.chatId
                                ? 'chatsListSelected'
                                : ''
                        "
                        class="chatContainer"
                        (mouseenter)="option.showActions = true"
                        (mouseleave)="option.showActions = false"
                        #itemElement
                    >
                      <span
                        *ngIf="option?.chatDocument?.length>0 "
                        class="bi bi-file-earmark-check ml-2"
                      ></span>
                      <i
                        *ngIf="option?.chatDocument?.length === 0 && option?.chatTables?.length === 0 && (option.chatType === 'normal' || !option.chatType || !(option.chatType !== 'QEC'  || option.chatType !== 'ESG') || option.chatType === deepResearchChatType)"
                        class="bi bi-chat-square-text ml-2"
                      ></i>
                      <i class="bi bi-recycle ml-2"  *ngIf="((option?.chatType && option?.chatType === ESGChatType))"></i>
                      <i class="bi bi-database ml-2"  *ngIf="((option?.chatTables?.length>0 && !option?.chatType)|| (option?.chatType && option?.chatType === QECChatType))"></i>
                      <i class="pi pi-globe ml-2"  *ngIf="((option?.chatType && option?.chatType === agenticWorkflowChatType))"></i>
                      <i class="pi pi-code ml-2"  *ngIf="((option?.chatType && option?.chatType === codeInterpreterChatType))"></i>
                      <img src="assets/images/imageChatIcon.svg" alt="Chat" class="ml-2" height="16" width="16" *ngIf="option?.chatConfig?.memoryChat && !isDocumentChat(option)">
                      <img src="assets/images/deepResearchChatIcon.svg" alt="Deep Research Chat Icon" class="ml-2" height="16" width="16" *ngIf="option?.chatType === deepResearchChatType">
                      
                        <div
                            *ngIf="
                                option.editName &&
                                activeChat?.chatId === option.chatId
                            "
                            (click)="$event.stopPropagation()"
                            tabindex="0"
                            role="button"
                            class="p-2 chatsList"
                        >
                            <input
                                pInputText
                                type="text"
                                (keyup)="getUpdatedName($event)"
                                (click)="$event.stopPropagation()"
                                [value]="option.chatName"
                                autofocus
                            />
                        </div>
                        <div
                          *ngIf="!option.editName || activeChat?.chatId !== option.chatId"
                          contenteditable="false"
                          (click)="checkChatUpdate(option); currentChatPeriod = chat.period"
                          (keydown.enter)="checkChatUpdate(option); currentChatPeriod = chat.period"
                          tabindex="0"
                          role="button"
                          class="p-2 chatsList"
                          pTooltip="{{ option.chatName }}"
                          tooltipPosition="top"
                        >
                          {{ option.chatName }}
                        </div>
                        <i
                            *ngIf="option.actionLoader"
                            class="pi pi-spin pi-spinner mr-2"
                        ></i>
                        <i
                            class="bi bi-three-dots-vertical mr-2 cursor"
                            (click)="chatOptionOverlay.toggle($event)"
                            (keydown.enter)="chatOptionOverlay.toggle($event)"
                            tabindex="0"
                            role="button"
                            pTooltip="Options"
                            tooltipPosition="top"
                            *ngIf="!option.editName && !option.actionLoader"
                        ></i>
                        <i
                            *ngIf="
                                activeChat?.chatId === option.chatId &&
                                option.editName
                            "
                            class="bi bi-check2 mr-2 cursor"
                            (click)="
                                option.editName = false;
                                option.chatName = updatedChatName;
                                editChatName()
                            "
                            (keydown.enter)="
                                option.editName = false;
                                option.chatName = updatedChatName;
                                editChatName()
                            "
                            tabindex="0"
                            role="button"
                        ></i>
                        <i
                            *ngIf="
                                activeChat?.chatId === option.chatId &&
                                option.editName
                            "
                            class="bi bi-x mr-1 cursor"
                            (click)="option.editName = false"
                            (keydown.enter)="option.editName = false"
                            tabindex="0"
                            role="button"
                        ></i>
                        

                        <p-overlayPanel styleClass="chatOption-overlay" #chatOptionOverlay [dismissable]="false">
                            <div class="chatOption-container" (click)="$event.stopPropagation()">
                                @if(activeChat?.chatId === option.chatId) {
                                  <div class="chatOption-item">
                                      <button
                                          class="p-button p-button-secondary w-full text-left"
                                          (click)="onOverlayAction($event, chatOptionOverlay, 'rename', option)"
                                      >
                                              <i class="bi bi-pencil-square mr-2"></i>Rename Title
                                          </button>
                                  </div>
                                }
                                <div class="chatOption-item">
                                    <button
                                        class="p-button p-button-secondary w-full text-left"
                                        (click)="onOverlayAction($event, chatOptionOverlay, 'bookmark', option, chat.period)"
                                    >
                                            <i 
                                                [ngClass]="option.isBookmarked ? 'pi pi-bookmark-fill':'pi pi-bookmark'"
                                                class="mr-2">
                                            </i>{{ option.isBookmarked ? "Remove Bookmark" : "Add Bookmark" }}
                                        </button>
                                </div>
                                <div class="chatOption-item">
                                    <button
                                        class="p-button p-button-secondary w-full text-left"
                                        (click)="onOverlayAction($event, chatOptionOverlay, 'delete', option, chat.period, i, idx)"
                                    >
                                            <i class="pi pi-trash mr-2"></i>Delete Chat
                                        </button>
                                </div>
                                
                                    
                            </div>
                        </p-overlayPanel>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="hidden-whitespace-detector" #whitespaceDetector>
      <div *ngIf="isLoadingOlderChats" class="loaderContainer">
        <div class="loaderSpinner"></div>
      </div>
    </div>
</div>



